import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import OtpInput from "react-otp-input";
import { Formik } from "formik";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { otpSchema } from "../../utils/schema";
import { format } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import {
  FetchUserDetail,
  ResendOtpCall,
  userDetailSelector,
  verifyOtpCall,
} from "../slice";
import { toast } from "react-toastify";
import Loader from "../../component/Loader";
import BackButton from "../../component/BackButton";
import { subdomainSelector } from "../subdomainSlice";

function OtpVerification() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [counter, setCounter] = React.useState(120);
  const [loading, setLoading] = useState(false);
  const subdomain = useSelector(subdomainSelector);


  // const user = JSON.parse(localStorage.getItem("forgetData"));
  const email = localStorage.getItem("email");
  const user = useSelector(userDetailSelector);
  const id = useSelector((store) => store.main.forgetData);
  useEffect(() => {
    dispatch(FetchUserDetail({}));
  }, [dispatch]);

  const {
    register,
    formState: { errors },
    handleSubmit,
    getValues,
    control,
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onSubmit",
    resolver: yupResolver(otpSchema),
    shouldFocusError: true,
  });


  useEffect(() => {
    let timer;
    if (counter > 0) {
      timer = setTimeout(() => setCounter((c) => c - 1), 1000);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [counter]);

  const onSubmit = (data) => {
    setLoading(true);
    dispatch(
      verifyOtpCall({
        userId: id,
        code: data?.otpValues,
        user_type: "user",
        url_id: subdomain
      })
    ).then(async (res) => {
      setLoading(false);
      if (res?.payload?.code === 1) {
        await localStorage.setItem("token_u", res?.payload?.data?.token);
        navigate("/reset-password", { replace: true });
        toast.success(res?.payload?.message);
      } else {
        toast.error(res?.payload?.message, {  autoClose: false,  closeButton: true});
      }
    });
  };

  const handleResend = () => {
    setLoading(true);
    dispatch(ResendOtpCall({ email: email, user_type: "user" })).then(
      async (res) => {
        setLoading(false);
        setCounter(10);
        if (res?.payload?.code === 1) {
          toast.success(res?.payload?.message);
        } else {
          toast.error(res?.payload?.message, {  autoClose: false,  closeButton: true});
        }
      }
    );
  };
  return (
    <section>
      <div className="container-fluid">
        <div className="row">
        <div className="col-sm-12 col-md-5 col-lg-5 d-flex justify-content-center order-2 order-md-1"
            style={{
              backgroundColor: 'white',
              minHeight: '100vh'
            }}
          >
            <div style={{ 
              width: '100%', 
              maxWidth: 500, 
              textAlign: 'center',
              padding: '0px 20px'
            }}>
              {/* Logo and Title Section */}
              <div style={{ 
                textAlign: 'left', 
                marginTop: 20, 
                marginBottom: 15, 
                display: 'flex',
                alignItems: 'flex-start',
                gap: '20px'
              }}>
                <img
                  src={localStorage.getItem('company_logo')}
                  alt="logo"
                  style={{
                    width: 100,
                    height: 100,
                    objectFit: 'cover',
                    borderRadius: '50%',
                  }}
                />
                <div>
                  <h2 style={{ 
                    fontWeight: 700, 
                    fontSize: '20px', 
                    color: '#23235b', 
                    margin: '25px 0 8px 0',
                    lineHeight: '1.0'
                  }}>
                    Recover Your Club Account
                  </h2>
                  <p style={{ 
                    fontSize: '16px', 
                    color: '#666', 
                    margin: 0,
                    fontWeight: 400
                  }}>
                    Powered by BookInClass
                  </p>
                </div>
              </div>

              {/* Help Section */}
              <div style={{
                backgroundColor: '#b3e6f9',
                color: 'white',
                padding: '12px 20px',
                marginBottom: '20px',
                fontWeight: 700,
                fontSize: '18px',
                textAlign: 'left', 
                color: '#23235b'
              }}>
                Help
              </div>

              {/* Instructions */}
              <div style={{ 
                textAlign: 'left',
                fontSize: '15px', 
                color: '#333', 
                lineHeight: 1.6,
                marginBottom: '15px'
              }}>

                <div style={{ fontWeight: 600, fontSize: '18px', marginBottom: '16px' }}>
                 Verify OTP!
                </div>
                <p style={{ marginBottom: '16px' }}>
                  We’ve sent a One-Time Password (OTP) to your registered email address.
                </p>
                <p style={{ marginBottom: '16px' }}>
                  Please enter the 6-digit OTP on the right to verify your identity and continue resetting your password.
                </p>
                <p style={{ marginBottom: '0px' }}>
                  The OTP is valid for a limited time.
                </p>
                <p style={{ marginBottom: '16px' }}>
                  Didn’t receive the email? Check your spam folder or click Resend OTP.
                </p>
                <p style={{ marginBottom: '16px' }}>
                  Still having trouble? Contact our support team for help.
                </p>
            </div>
            </div>
          </div>
        <div className="col-sm-12 col-md-7 col-lg-7 order-1 order-md-2" style={{backgroundColor: '#b3e6f9'}}>
            <BackButton />
            <div className="form-style mt-5">
              <form className="row" onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group col-sm-12 col-md-12 text-center mb-5">
                  <div className="">
                    <img
                      src="assets/img/otp.png"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                </div>
                <div className="form-group col-sm-12 col-md-12 text-center mb-4">
                  <h2 className="mdl-ttl">OTP Verification</h2>
                  <p>
                    Please enter 6 digit code which has been send on your
                    <br /> registered email address.
                  </p>
                  {error && <div className="alert alert-danger">{error}</div>}
                </div>
                <div className="form-group col-sm-12 col-md-12 mb-4">
                  <div className="passcode-wrapper d-flex justify-content-center">
                    {/* <input
                        id="codeBox1"
                        type="number"
                        maxlength="1"
                        placeholder="0"
                      /> */}
                    <Controller
                      render={({ field: { onChange, value } }) => (
                        <OtpInput
                          value={value}
                          onChange={(val) => {
                            if (val) {
                              onChange(val);
                            }
                          }}
                          placeholder="000000"
                          inputStyle="otpInputs"
                          numInputs={6}
                          // separator={<span> </span>}
                          renderSeparator={<span> </span>}
                          renderInput={(props) => <input {...props} />}
                        />
                      )}
                      name="otpValues"
                      control={control}
                    />
                  </div>
                  {errors?.otpValues && (
                    <div className="text-red">{errors?.otpValues?.message}</div>
                  )}
                </div>
                {/* <div className="form-group col-sm-12 col-md-12 text-center">
                  <p className="otp-timing">00:35</p>
                </div> */}
                <div className="form-group col-sm-12 col-md-12 text-center">
                  <button className="btn btn-submit" type="submit" style={{ width: "100%" }}>
                    {loading ? <Loader /> : "Verify"}
                  </button>
                </div>
                <div className="form-group col-sm-12 col-md-12 text-center mb-4">
                  <div>
                    {counter === 0 ? (
                      <span
                        className="forgot-pass cursor-pointer p-0"
                        onClick={() => {
                          handleResend();
                        }}
                      >
                        Resend Code
                      </span>
                    ) : (
                      <div>Resend code in {format(counter)}</div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OtpVerification;
